export const senecChipTheme = {
    styleOverrides: {
        root: {
            borderRadius: "8px",
            padding: "4px 4px",
        },
        label: {
            fontWeight: 500,
            paddingLeft: 8,
            paddingRight: 8,
        },
    },
};
